import { BlockOneshopUpdatingOptionsSummary } from 'shared/api/client';
import { FormattedProps } from './types';
import { getLinkHref } from 'shared/helpers/uri';
import { Link, PropsFormatterUtils, TitleHtmlTag } from 'shared/types';
import { EngagementUnit } from '../../shared/types';

export default function propsFormatter(
  content: BlockOneshopUpdatingOptionsSummary['content'],
  { getLinkHrefWithAuthentication }: PropsFormatterUtils
): FormattedProps {
  return {
    title: {
      label: content.title.label ?? '',
      htmlTag: content.title.htmlTag
        ? (content.title.htmlTag as TitleHtmlTag)
        : undefined
    },
    subtitle: content.subtitle,
    productEngagementUnit: content.product?.engagementUnit
      ? EngagementUnit[content.product.engagementUnit]
      : null,
    totalLabel: content.total_label,
    submitButton: {
      label: content.submit_button.label ?? '',
      link: getLinkHrefWithAuthentication(
        content.submit_button.link ? (content.submit_button.link as Link) : null
      )
    },
    previousButtonLabel: content.previous_button.label ?? null,
    redirectLinkToStart: getLinkHref(content.redirect_link_to_start as Link),
    apiUpdatingOptionsSummary: {
      method:
        content.apis.crm_management_acts_updating_options_summary?.method ??
        'POST',
      url: content.apis.crm_management_acts_updating_options_summary?.url ?? ''
    }
  };
}
